import {Component} from 'react';
import h from 'react-hyperscript';
import './TransformationProgressDetail.scss';
import BasicCard from 'Components/Cards/BasicCard';
import Button from 'Components/Buttons/Buttons';
import {h4, eyebrow, p} from 'Components/Typography/Typography';
import AccordionItem from './AccordionItem/AccordionItem';
import {
  getAvg,
  toCamelCase,
  isArrayEmpty,
  setZeroIfInvalidNumber,
  getPercentageDifference,
  getPercentValue} from 'Src/utils/utils';
import ReportError from 'Components/ErrorMessage/ReportError';
import TooltipGroup from 'Components/TooltipGroup/TooltipGroup';
import ProgressBar from 'Components/DataViz/ProgressBar/ProgressBar';
import Benchmarking from 'Components/Benchmarking/Benchmarking';
import {formatDatetimeLong} from 'Src/utils/utils';

class TransformationProgressDetail extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      expandedList: [],
      isExpandAll: false,
      hasError: false,
      respondents: 0,
    };
    this.handleAccordionToggle = this.handleAccordionToggle.bind(this);
    this.handleExpandAllToggle = this.handleExpandAllToggle.bind(this);
  }

  componentWillMount() {
    this._isMounted = true;
    this.setData();
  }

  setData() {
    if (this._isMounted) {
      if (!this.dataAvailable) {
        this.setHasError(true);
      } else {
        this.setHasError(false);
        const totalTransformationProgress =
          this.getTotalTransformationProgress(this.props.surveyResults);
        this.setTotalProgress('totalProgress', totalTransformationProgress);

        if (this.props.surveyResultsPrev) {
          const totalTransformationProgressPrev =
            this.getTotalTransformationProgress(this.props.surveyResultsPrev);
          this.setTotalProgress(
              'totalProgressPrev',
              totalTransformationProgressPrev
          );
        }
        this.setRespondents(this.props.surveyResults.__num_respondents);
      }
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps) {
    if (this.props.surveyResults !== prevProps.surveyResults) {
      this.setRespondents(this.props.surveyResults.__num_respondents);
    }
  }

  get alternateResources() {
    const transformationElements = this.props.transformationElements;

    return Array.isArray(this.props.transformationElements) ?
      transformationElements.reduce((resources, {id, alternateResources}) => {
        return {
          ...resources,
          [id]: alternateResources,
        };
      }, {}) : [];
  }

  get dataAvailable() {
    const {transformationElements, hasSurveyResults, surveyResults} =
      this.props;
    return !isArrayEmpty(transformationElements) && hasSurveyResults &&
      surveyResults;
  }

  getTotalTransformationProgress(surveyResults) {
    const elements = Object.keys(surveyResults);
    elements.shift();
    const averages = elements.map((element) => {
      return surveyResults[element].__average;
    });
    return getAvg(averages);
  }

  setHasError(value) {
    this.setState({
      isLoaded: true,
      hasError: value,
    });
  }

  setRespondents(value) {
    const respondents = setZeroIfInvalidNumber(value);
    this.setState({respondents});
  }

  setTotalProgress(key, value) {
    this.setState({
      [key]: value,
    });
  }

  handleAccordionToggle(e) {
    e.preventDefault();

    const clickedEl = e.currentTarget.parentNode;
    const headerHeight = clickedEl.offsetHeight;
    const parent = clickedEl.parentNode;
    const contentHeight =
      parent.getElementsByClassName('accordion__item__content')[0].offsetHeight;
    const clickedIndex = Number(clickedEl.getAttribute('dataaccordion'));
    const expandedIndexes = this.state.expandedList;

    if (expandedIndexes.includes(clickedIndex)) {
      const target = expandedIndexes.indexOf(clickedIndex);
      if (target > -1) {
        expandedIndexes.splice(target, 1);
        clickedEl.parentNode.classList.remove('active');
        clickedEl.classList.remove('active');
        clickedEl.parentNode.style.height = headerHeight;
      }
    } else {
      expandedIndexes.push(clickedIndex);
      clickedEl.parentNode.classList.add('active');
      clickedEl.classList.add('active');
      clickedEl.parentNode.style.height = headerHeight + contentHeight;
    }

    this.setExpanded(expandedIndexes);
  }

  setExpanded(value) {
    const {transformationElements} = this.props;

    this.setState({
      expandedList: value,
    }, () => {
      if (transformationElements.length === this.state.expandedList.length) {
        this.setExpandAll(true);
      } else {
        this.setExpandAll(false);
      }
    });
  }

  setExpandAll(value) {
    this.setState({
      isExpandAll: value,
    });
  }

  handleExpandAllToggle(e) {
    e.preventDefault();
    if (this.state.isExpandAll) {
      this.setExpanded([]);
    } else {
      const indexes = this.props.transformationElements.map((el, i) => {
        return i;
      });
      this.setExpanded(indexes);
    }
  }

  reportErrorMessage() {
    const {title, subtitle, paragraph} = this.props.errorMessage;

    return h('div', {
      id: this.props.id,
      className: `${this.props.className} has-error`,
    }, [
      h(h4, {
        key: 'title__key',
        className: 'card__title',
      }, title),
      h(h4, subtitle),
      h('div', [
        h('div', {className: 'margin-bottom--micro'}, paragraph.partOne),
        paragraph.partTwo,
        h('a', {
          className: 'cta text--blue',
          href: paragraph.partThree.href,
          target: '_blank',
        }, paragraph.partThree.label),
        ' ',
        paragraph.partFour,
        h('a', {
          className: 'cta text--blue',
          href: paragraph.partFive.href,
          target: '_blank',
        }, paragraph.partFive.label),
        '; ',
        h('a', {
          className: 'cta text--blue',
          href: paragraph.partSix.href,
          target: '_blank',
        }, paragraph.partSix.label),
        paragraph.partSeven,
      ]),
    ]);
  }

  render() {
    const {
      isExpandAll,
      hasError,
      totalProgress,
      totalProgressPrev,
    } = this.state;
    const {survey_results_labels: surveyLabels} = this.props;
    const alternateResources = this.alternateResources;

    const percentage = setZeroIfInvalidNumber(totalProgress);

    const progressComponents = [
      h(ProgressBar, {
        value: percentage,
        height: 10,
        width: 150,
        color: surveyLabels.survey_progress.color,
      }, null),
      h(h4, {
        className: 'padding-left--md',
      }, `${getPercentValue(percentage)}%`),
    ];

    if (!isNaN(totalProgressPrev)) {
      const percentagePrev = setZeroIfInvalidNumber(totalProgressPrev);
      const change = getPercentageDifference(percentage, percentagePrev);

      progressComponents.push(
          h(Benchmarking, {change,
            className: 'padding-left--micro padding-bottom--micro-2',
          })
      );
    }

    return (
      h('div', null, [
          hasError ? h('div', {
            className: 'row',
          }, h(BasicCard, {
            id: this.props.id,
            className: this.props.className,
          }, h(ReportError, {
            message: this.reportErrorMessage(),
          }, null))) : null,
          h('div', {
            className: 'row',
          }, h(BasicCard, {
            id: this.props.id,
            className: this.props.className,
          }, [
            h('div', null, [
              h('div', {
                key: 'transformation-detail-title',
                className: 'flex--space-between',
                id: 'title',
              }, [
                h(h4, {
                  key: 'title__key',
                  className: 'card__title',
                }, hasError ? this.props.title_alt : this.props.title),
              ]),

              h('div', {
                key: 'transformation-detail-subtitle',
                className: 'flex--space-between',
                id: 'subtitle',
              }, [
                h(p, {
                  key: 'subtitle__key',
                  className: 'card__subtitle',
                }, hasError ? '' : `As of ${
                  formatDatetimeLong(this.props.reportAvailableDate)}`),
              ]),
            ]),
            h('div', {
              key: 'survey-results__key',
              className: 'flex--space-between survey-results',
              id: 'survey-results',
            }, [
              h('div', {
                id: 'survey-results__respondents',
              }, [
                h(eyebrow, {
                  key: 'accordion-title__key',
                  className: 'padding-bottom--micro',
                }, surveyLabels.survey_respondents.title),
                h(h4, {
                  className: 'flex',
                }, [
                  h('span', {
                    className: 'material-icons padding-right--micro',
                  }, surveyLabels.survey_respondents.icon),
                  this.state.respondents,
                ]),
              ]),
              h('div', {
                id: 'survey-results__progress',
              }, [
                h(TooltipGroup, {
                  title: surveyLabels.survey_progress.tooltip,
                }, h(eyebrow, {
                  className: 'padding-bottom--micro',
                }, surveyLabels.survey_progress.title)),
                h('div', {
                  className: 'flex--space-between--all progress-bar__container',
                }, progressComponents),
              ]),
            ]),
            h('div', {
              key: 'accordion-title__key',
              className: 'flex--space-between--all',
              id: 'accordion__title',
            }, [
              h(eyebrow, {
                key: 'accordion-title__key',
                className: 'card__title',
              }, this.props.subhead_detail),
              h(Button, {
                key: 'expand-all-button__key',
                type: 'inline',
                className: 'card__title',
                to: '#',
                tabIndex: 0,
                onClick: this.handleExpandAllToggle,
              }, [
                h('span', {
                  key: 'survey-messaging-cta-title',
                }, isExpandAll ? 'Collapse All' : 'Expand All'),
                h('span', {
                  key: 'survey-messaging-cta-link',
                  className: `material-icons padding-right--micro${
                    isExpandAll ? ' arrow-rotate' : ''
                  }`,
                }, 'keyboard_arrow_down'),
              ]),
            ]),
            h('div', {
              key: 'accordion__items',
            }, [
              this.props.transformationElements.map((item, i) => {
                const {id} = item;

                return (
                  h(AccordionItem, {
                    key: i,
                    i: i,
                    id,
                    item: item,
                    hasError,
                    data: !hasError ? this.props.surveyResults[
                        `${toCamelCase(id)}Values`] : null,
                    dataPrev: this.props.surveyResultsPrev ?
                      this.props.surveyResultsPrev[`${toCamelCase(id)}Values`] :
                      null,
                    chartName: this.props.chartName,
                    chartNamePrev: this.props.chartNamePrev,
                    expandedList: this.state.expandedList,
                    elementSteps: this.props.elementSteps,
                    alternateResources: alternateResources[id],
                    handleAccordionToggle: this.handleAccordionToggle,
                    transformationResources: this.props.transformationResources,
                    chartHelpText: this.props.chartHelpText,
                  }, null)
                );
              }),
            ]),
          ])),
      ])
    );
  }
}

export default TransformationProgressDetail;
